import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestFormPage.NetSuiteVendorForm', {
    popupTitle: 'New Vendor',
    createButton: 'Create',
    primaryInformationSection: 'Primary Information',
    contactInformationSection: 'Contact Information',
    financialInformationSection: 'Financial Information',
    subsidiariesSection: 'Subsidiaries',
    currenciesSection: 'Currencies',
    addressesSection: 'Addresses',
    isCompany: 'Company',
    isIndividual: 'Individual',
    companyName: 'Company name',
    webAddress: 'Web Address',
    salutation: 'Salutation',
    firstName: 'First name',
    middleName: 'Middle name',
    lastName: 'Last name',
    category: 'Category',
    comments: 'Comments',
    jobTitle: 'Job title',
    email: 'Email',
    phone: 'Phone',
    altPhone: 'Alt phone',
    fax: 'Fax',
    legalName: 'Legal name',
    accountNumber: 'Account Number',
    defaultExpenseAccount: 'Default expense account',
    defaultPayablesAccount: 'Default payables account',
    terms: 'Terms',
    incoterm: 'Incoterm',
    taxNumber: 'Tax id',
    is1099Eligible: 'Is 1099 eligible',
    isJobResource: 'Is job resource',
    primarySubsidiary: 'Primary Subsidiary',
    subsidiary: 'Subsidiary',
    creditLimit: 'Credit limit',
    taxCode: 'Tax code',
    primaryCurrency: 'Primary currency',
    currenciesList: 'Currencies list',
    defaultShipping: 'Default shipping',
    defaultBilling: 'Default billing',
    label: 'Label',
    country: 'Country',
    attention: 'Attention',
    addressee: 'Addressee',
    primaryAddress: 'Address 1',
    secondaryAddress: 'Address 2',
    city: 'City',
    state: 'State',
    zip: 'Zip',
    inputPlaceholder: 'Enter value',
    selectPlaceholder: 'Select value',
    mandatoryError: 'Please fill in all mandatory fields.',
    duplicatedSubsidiary: 'Subsidiary in table should be unique.',
    invalidWebAddress: 'Web address should be a valid URL',
});
